var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0007 2.83334C6.91732 2.83334 2.83398 6.91667 2.83398 12C2.83398 17.0833 6.91732 21.1667 12.0007 21.1667C17.084 21.1667 21.1673 17.0833 21.1673 12C21.1673 6.91667 17.084 2.83334 12.0007 2.83334ZM19.4173 11.1667H16.084C15.9173 8.83334 15.1673 6.66667 13.834 4.75C16.834 5.5 19.084 8.08334 19.4173 11.1667ZM14.5007 12.8333H9.58398C9.75065 15.0833 10.584 17.25 12.084 19C13.4173 17.25 14.2507 15.0833 14.5007 12.8333ZM9.58398 11.1667C9.83398 8.91667 10.6673 6.75 12.0007 5C13.4173 6.83334 14.2507 9 14.4173 11.1667H9.58398ZM7.91732 11.1667C8.08398 8.83334 8.83398 6.66667 10.084 4.75C7.16732 5.5 4.91732 8.08334 4.58398 11.1667H7.91732ZM4.58398 12.8333H7.91732C8.08398 15.1667 8.83398 17.3333 10.1673 19.25C7.16732 18.5 4.91732 15.9167 4.58398 12.8333ZM16.1673 12.8333C15.9173 15.1667 15.1673 17.3333 13.9173 19.25C16.834 18.5 19.084 15.9167 19.5007 12.8333H16.1673Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.b0021a93.svg";
export { ForwardRef as ReactComponent };